import { DataBean } from "../DataBean";

export class ExportProdcutionOrderIn extends DataBean {



    public async exportWIPProductionOrdersProcessQueue(year: number, month: number, idEmployee: number): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.cache.bean.ProcessQueue_exportWIPProductionOrdersProcessQueue_Number_Number_Number", [year, month, idEmployee]);
    }

    public async exportWIPProductionOrders(year: any, month: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportWIPProductionOrders_Number_Number", [year, month]);
    }

    public async exportProductionOrdersForClose(year: any, month: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportProductionOrdersForClose_Number_Number", [year, month]);
    }

    public async executeCloseProductionForClose(year: any, month: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_executeCloseProductionForClose_Number_Number", [year, month]);
    }
}